import { render, staticRenderFns } from "./PendingRegistrationIcon.vue?vue&type=template&id=2018f000"
import script from "./PendingRegistrationIcon.vue?vue&type=script&lang=js"
export * from "./PendingRegistrationIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports